import LinkFacebook, {
	LinkFacebookProps as _LinkFacebookProps,
} from './LinkFacebook';

export { LinkFacebook };
export type LinkFacebookProps = _LinkFacebookProps;
